/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) { if (typeof j != "undefined") { m = m || {}; if (j === null) { j = ""; m.expires = -1 } var e = ""; if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) { var f; if (typeof m.expires == "number") { f = new Date(); f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000)) } else { f = m.expires } e = "; expires=" + f.toUTCString() } var l = m.path ? "; path=" + (m.path) : ""; var g = m.domain ? "; domain=" + (m.domain) : ""; var a = m.secure ? "; secure" : ""; document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("") } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d } };

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

Shopify.Products = (function () {
    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: 'recently-viewed-products',
        templateId: 'recently-viewed-product-template',
        layout: 'slider',
        swipe: true,
        media: 'adapt',
        onComplete: null
    };
    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;
    var shownSection = 0;
    var cookie = {
        configuration: {
            expires: 90,
            path: '/',
            domain: window.location.hostname
        },
        name: 'shopify_recently_viewed',
        write: function (recentlyViewed) {
            jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
            localStorage.setItem(this.name, recentlyViewed.join(' '), this.configuration);
        },
        read: function () {
            var recentlyViewed = [];
            var cookieValue = jQuery.cookie(this.name);
            var localStorageValue = localStorage.getItem('shopify_recently_viewed');
            
            // TEST: Inject a bogus product handle for testing invalid URL handling
            // Remove this block after testing is complete
            // var existingValue = cookieValue || localStorageValue || '';
            // if (existingValue && existingValue.indexOf('bogus-test-product-does-not-exist') === -1) {
            //     existingValue = 'bogus-test-product-does-not-exist ' + existingValue;
            //     jQuery.cookie(this.name, existingValue, this.configuration);
            //     localStorage.setItem(this.name, existingValue);
            //     cookieValue = existingValue;
            //     console.log('TEST: Injected bogus product handle for testing. New value:', existingValue);
            // }
            // END TEST BLOCK
            
            //console.log('shopify_recently_viewed cookie value:', cookieValue);
            //console.log('shopify_recently_viewed localStorage value:', localStorageValue);
            
            if (Shopify.designMode && !cookieValue) {
                cookieValue = localStorageValue;
            }
            if (cookieValue !== null) {
                recentlyViewed = cookieValue.split(' ').filter(function(handle) {
                    return handle && handle.trim() !== '';
                });
            }
            //console.log('Filtered recently viewed handles:', recentlyViewed);
            return recentlyViewed;
        },
        destroy: function () {
            jQuery.cookie(this.name, null, this.configuration);
        },
        remove: function (productHandle) {
            var recentlyViewed = this.read();
            //console.log('Attempting to remove handle:', productHandle);
            //console.log('Current recently viewed list:', recentlyViewed);
            
            var position = jQuery.inArray(productHandle, recentlyViewed);
            //console.log('Position found:', position);
            
            if (position !== -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
                //console.log('Successfully removed. New list:', recentlyViewed);
            } else {
                //console.log('Product handle not found in recently viewed list');
            }
        }
    };

    var finalize = function () {
        var items = wrapper.find('.item')
        if (items.length <= 2) $('#recently-viewed-products-list').addClass('center');

        $('#recently-viewed-products-list-2').addClass('recently-viewed-loaded');

        wrapper.show();
        // If we have a callback.
        if (config.onComplete) {
            try {
                config.onComplete();
            } catch (error) { }
        }
    };

    var moveAlong = function (wrapperP) {
        if (productHandleQueue.length && shown < config.howManyToShow) {
            var url = window.routes.root + '/products/' + productHandleQueue[shown] + '?view=ajax_recently_viewed';

            jQuery.ajax({
                type: 'get',
                url: url,
                cache: false,
                success: function (product, textStatus, jqXHR) {
                    // Check if the response is a valid product (not a redirect to any other page)
                    // If product was redirected, the response won't contain product-specific elements
                    var $tempProduct = $('<div>').html(product);
                    
                    // Check for valid product content - must have product-specific elements
                    var hasProductItem = $tempProduct.find('.product-item').length > 0 || product.indexOf('product-item') !== -1;
                    var hasProductCard = $tempProduct.find('.card').length > 0;
                    var hasProductHandle = $tempProduct.find('[data-product-handle]').length > 0 || product.indexOf('data-product-handle') !== -1;
                    var hasProductLink = $tempProduct.find('a[href*="/products/"]').length > 0;
                    
                    // Must have at least product-item class or product handle attribute (core product card elements)
                    var isValidProduct = hasProductItem || hasProductHandle;
                    
                    // Check if response contains indicators of non-product pages (redirects)
                    // This catches redirects to homepage, collections, pages, blogs, cart, etc.
                    var hasNonProductPageIndicators = 
                        product.indexOf('template-index') !== -1 ||           // Homepage
                        product.indexOf('template-collection') !== -1 ||      // Collection
                        product.indexOf('template-page') !== -1 ||            // Regular page
                        product.indexOf('template-blog') !== -1 ||            // Blog
                        product.indexOf('template-article') !== -1 ||         // Article
                        product.indexOf('template-cart') !== -1 ||            // Cart
                        product.indexOf('template-404') !== -1 ||             // 404 page
                        product.indexOf('template-search') !== -1 ||          // Search
                        product.indexOf('shopify-section-template--') !== -1 || // Section template indicators
                        $tempProduct.find('[class*="template-index"]').length > 0 ||
                        $tempProduct.find('[class*="template-collection"]').length > 0 ||
                        $tempProduct.find('[class*="template-page"]').length > 0;
                    
                    // Also check if response is too large (likely a full page instead of a product card)
                    var isTooLarge = product.length > 50000; // Product cards should be much smaller than this
                    
                    // Also check if response is empty or too small to be valid
                    var isTooSmall = product.trim().length < 100;
                    
                    if (isValidProduct && !hasNonProductPageIndicators && !isTooLarge && !isTooSmall) {
                        wrapperP.append(product);
                        shown++;
                        moveAlong(wrapperP);
                    } else {
                        // Invalid product - remove from cookie and continue
                        console.log('Invalid product detected (redirect or empty), removing:', productHandleQueue[shown]);
                        cookie.remove(productHandleQueue[shown]);
                        shown++;
                        moveAlong(wrapperP);
                    }
                },
                error: function () {
                    cookie.remove(productHandleQueue[shown]);
                    shown++;
                    moveAlong(wrapperP);
                }
            });
        } else {
            finalize();
        }
    };

    var doAlong = function (wrapperS) {
        const recentlyViewed = wrapperS.parents('.halo-recently-viewed-block');

        if (productHandleQueue.length && shownSection < config.howManyToShow) {
            // Skip empty or invalid product handles
            var currentHandle = productHandleQueue[shownSection];
            if (!currentHandle || currentHandle.trim() === '') {
                //console.log('Skipping empty product handle at index:', shownSection);
                shownSection++;
                doAlong(wrapperS);
                return;
            }
            
            var url = window.routes.root + '/products/' + currentHandle + '?view=ajax_recently_viewed';
            
            //console.log('AJAX URL:', url);

            jQuery.ajax({
                type: 'get',
                url: url,
                cache: false,
                dataType: 'html',
                success: function (product) {
                    //console.log('AJAX response length:', product.length);
                    //console.log('AJAX response preview:', product.substring(0, 200));
                    
                    // Create a temporary container to parse the HTML
                    var $tempContainer = $('<div>').html(product);
                    
                    // Check for valid product content - must have product-specific elements
                    var hasProductItem = $tempContainer.find('.product-item').length > 0 || product.indexOf('product-item') !== -1;
                    var hasProductHandle = $tempContainer.find('[data-product-handle]').length > 0 || product.indexOf('data-product-handle') !== -1;
                    
                    // Must have at least product-item class or product handle attribute (core product card elements)
                    var isValidProduct = hasProductItem || hasProductHandle;
                    
                    // Check if response contains indicators of non-product pages (redirects)
                    // This catches redirects to homepage, collections, pages, blogs, cart, etc.
                    var hasNonProductPageIndicators = 
                        product.indexOf('template-index') !== -1 ||           // Homepage
                        product.indexOf('template-collection') !== -1 ||      // Collection
                        product.indexOf('template-page') !== -1 ||            // Regular page
                        product.indexOf('template-blog') !== -1 ||            // Blog
                        product.indexOf('template-article') !== -1 ||         // Article
                        product.indexOf('template-cart') !== -1 ||            // Cart
                        product.indexOf('template-404') !== -1 ||             // 404 page
                        product.indexOf('template-search') !== -1 ||          // Search
                        product.indexOf('shopify-section-template--') !== -1 || // Section template indicators
                        $tempContainer.find('[class*="template-index"]').length > 0 ||
                        $tempContainer.find('[class*="template-collection"]').length > 0 ||
                        $tempContainer.find('[class*="template-page"]').length > 0;
                    
                    // Also check if response is too large (likely a full page instead of a product card)
                    var isTooLarge = product.length > 50000; // Product cards should be much smaller than this
                    
                    // Also check if response is empty or too small to be valid
                    var isTooSmall = product.trim().length < 100;
                    
                    if (!isValidProduct || hasNonProductPageIndicators || isTooLarge || isTooSmall) {
                        // Invalid product - remove from cookie and continue
                        console.log('Invalid product detected (redirect or empty), removing:', currentHandle);
                        cookie.remove(currentHandle);
                        shownSection++;
                        doAlong(wrapperS);
                        return;
                    }
                    
                    // Remove ALL script tags to prevent conflicts
                    $tempContainer.find('script').remove();
                    
                    // Get the cleaned HTML content
                    var cleanedProduct = $tempContainer.html();
                    
                    // The product-card-02 snippet already includes the proper structure
                    // Just wrap it in a product div for the slider
                    var wrappedProduct = '<div class="product">' + cleanedProduct + '</div>';
                    
                    wrapperS.append(wrappedProduct);
                    if (shownSection == 0) {
                        const productLoading = wrapperS.find('.product-item--loadingNoInfo').parents('.product');
                        productLoading.remove();
                    }
                    shownSection++;
                    doAlong(wrapperS);
                },
                error: function () {
                    // Remove the invalid product handle from cookie/localStorage
                    console.log('BEFORE removal - Cookie:', jQuery.cookie('shopify_recently_viewed'));
                    console.log('BEFORE removal - localStorage:', localStorage.getItem('shopify_recently_viewed'));
                    console.log('Removing invalid product handle from storage:', currentHandle);
                    cookie.remove(currentHandle);
                    console.log('AFTER removal - Cookie:', jQuery.cookie('shopify_recently_viewed'));
                    console.log('AFTER removal - localStorage:', localStorage.getItem('shopify_recently_viewed'));
                    shownSection++;
                    doAlong(wrapperS);
                }
            });
        } else {
            if (productHandleQueue.length == 0) {
                recentlyViewed.hide();
                return;
            }

            if (config.layout == 'slider') {
                var productGrid = wrapperS,
                    itemToShow = productGrid.data('item-to-show'),
                    itemDots = productGrid.data('item-dots'),
                    itemDotsMb = productGrid.data('item-dots-mb'),
                    itemArrows = productGrid.data('item-arrows'),
                    itemArrowsMb = productGrid.data('item-arrows-mb');

                if (productGrid.length > 0) {
                    if (productGrid.not('.slick-initialized')) {

                        $('.recentlyViewed-row.products-carousel').attr('data-recent-products-number');
                        

                       
                        var slidesCount;
                        var sliderCounter = $('.recentlyViewed-row.products-carousel');
                        

                        
                        var updateSliderCounter = function(slick, currentIndex) {
                          currentSlide = slick.slickCurrentSlide() + 1;
                          slidesCount = slick.slideCount;
                          $(sliderCounter).attr('data-recent-products-number', slidesCount);

                        
                        };

                        productGrid.on('init', function(event, slick) {
                            updateSliderCounter(slick);

                            // console.log($('.recentlyViewed-row.products-carousel .slick-slide:not(.slick-cloned)').length );                            

                            //reloadStampedBadges();            
                            //console.log('reloadStampedBadges() 3');

                            if (typeof judgemeWidget !== 'undefined') {
                                judgemeWidget.init();
                            }



                          });
                        
                          productGrid.on('afterChange', function(event, slick, currentSlide) {
                            //updateSliderCounter(slick);

                            //console.log($('.recentlyViewed-row.products-carousel .slick-slide:not(.slick-cloned)').length );

                          });


                       /* productGrid.slick({
                            //mobileFirst: true,
                            mobileFirst: false,
                            adaptiveHeight: true,
                            vertical: false,
                            infinite: true,
                            //slidesToShow: 1,
                            slidesToShow: 7,
                            slidesToScroll: 1,
                            arrows: itemArrowsMb,
                            dots: itemDotsMb,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive:
                                [
                                    {
                                        breakpoint: 2200,
                                        settings: {
                                            arrows: itemArrows,
                                            dots: itemDots,
                                        
                                            get slidesToShow() {
                                            
                                                return this.SlidesToShow = 6;
                                            

                                            },
                                        
                                        
                                            get slidesToScroll() {
                                                /*if (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') {
                                                    return this.slidesToScroll = itemToShow;
                                                } else {
                                                    return this.slidesToScroll = 1;
                                                }* /
                                                return  this.slidesToScroll  = 1;
                                            }
                                        }
                                    },
                                    {
                                        breakpoint: 1820,
                                        settings: {
                                            arrows: itemArrows,
                                            dots: itemDots,
                                           
                                            get slidesToShow() {
                                             
                                                return this.SlidesToShow = 5;
                                               

                                            },
                                          
                                           
                                            get slidesToScroll() {
                                                /*if (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') {
                                                    return this.slidesToScroll = itemToShow;
                                                } else {
                                                    return this.slidesToScroll = 1;
                                                }* /
                                                return  this.slidesToScroll  = 1;
                                            }
                                        }
                                    },
                                    {
                                        //breakpoint: 1599,
                                        //breakpoint: 1460,
                                        breakpoint: 1470,
                                        settings: {
                                            arrows: itemArrows,
                                            dots: itemDots,
                                            //swipeToSlide: true,
                                            //centerMode: true,
                                            //variableWidth: true,
                                            get slidesToShow() {
                                                /*if (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') {
                                                    return this.slidesToShow = itemToShow;
                                                } else {
                                                    return this.slidesToShow = 1;
                                                }*/

                                                /*if( slidesCount == 4 || slidesCount == 5 ){
                                                    return this.slidesToShow = slidesCount - 1;
                                                } 

                                                else if ( slidesCount == 2) {
                                                        
                                                    return this.SlidesToShow = 3;

                                                } else if ( slidesCount > 6) {
                                                    
                                                    return this.SlidesToShow = 4;


                                                } else if ( slidesCount % 2 === 0) {

                                                    //return this.SlidesToShow = 3;

                                               
                                                } else if ( slidesCount == 1) {
                                                    
                                                    return this.SlidesToShow = 1;

                                                } else {

                                                    return this.SlidesToShow = 3;
                                                }* /
                                                //return this.SlidesToShow = 3;
                                                return this.SlidesToShow = 4;
                                               

                                            },
                                            /*get variableWidth() {
                                                /*if (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') {
                                                    return this.slidesToShow = itemToShow;
                                                } else {
                                                    return this.slidesToShow = 1;
                                                }* /

                                                if ( slidesCount % 2 === 0) {

                                                    

                                               

                                                } else if ( slidesCount == 1) {
                                                    
                                                   

                                                } else {

                                                    return this.variableWidth = true;
                                                }

                                               

                                            },* /
                                           
                                            get slidesToScroll() {
                                                /*if (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') {
                                                    return this.slidesToScroll = itemToShow;
                                                } else {
                                                    return this.slidesToScroll = 1;
                                                }* /
                                                return  this.slidesToScroll  = 1;
                                            }
                                        }
                                    },
                                    /*{
                                        breakpoint: 1024,
                                        settings: {
                                            arrows: itemArrows,
                                            dots: itemDots,
                                            get slidesToShow() {
                                                if (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') {
                                                    if (itemToShow == 5) {
                                                        return this.slidesToShow = itemToShow - 1;
                                                    } else {
                                                        return this.slidesToShow = itemToShow;
                                                    }
                                                } else {
                                                    return this.slidesToShow = 1;
                                                }
                                            },
                                            get slidesToScroll() {
                                                if (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') {
                                                    if (itemToShow == 5) {
                                                        return this.slidesToScroll = itemToShow - 1;
                                                    } else {
                                                        return this.slidesToScroll = itemToShow;
                                                    }
                                                } else {
                                                    return this.slidesToScroll = 1;
                                                }
                                            }
                                        }
                                    },* /
                                    {
                                        breakpoint: 1280,
                                        settings: {
                                            arrows: itemArrowsMb,
                                            dots: itemDotsMb,
                                            slidesToShow: 1,
                                            slidesToScroll: 1,
                                            centerMode: true,
                                            variableWidth: true
                                        }
                                    },
                                    {
                                        breakpoint: 767,
                                        settings: {
                                            arrows: itemArrowsMb,
                                            dots: itemDotsMb,
                                            slidesToShow: 1,
                                            slidesToScroll: 1,
                                            centerMode: true,
                                            variableWidth: true
                                        }
                                    },
                                    {
                                        breakpoint: 320,
                                        settings: {
                                            arrows: itemArrowsMb,
                                            dots: itemDotsMb,
                                            slidesToShow: 1,
                                            slidesToScroll: 1,
                                            centerMode: true,
                                            variableWidth: true
                                        }
                                    }
                                ]
                        }); */

                        productGrid.slick({
                            //mobileFirst: true,
                            mobileFirst: false,
                            adaptiveHeight: true,
                            vertical: false,
                            infinite: true,
                            //slidesToShow: 1,
                            slidesToShow: 6,
                            slidesToScroll: 6,
                            arrows: itemArrowsMb,
                            dots: itemDotsMb,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive:
                            [
                                {
                                breakpoint: 2600,
                                    settings: {
                                        arrows: itemArrows,
                                        dots: itemDots,
                                        slidesToShow: 9,
                                        slidesToScroll: 9
                                    }
                                },
                                 {
                                breakpoint: 2300,
                                    settings: {
                                        arrows: itemArrows,
                                        dots: itemDots,
                                        slidesToShow: 7,
                                        slidesToScroll: 7
                                    }
                                },
                                {
                                breakpoint: 2100,
                                    settings: {
                                        arrows: itemArrows,
                                        dots: itemDots,
                                        slidesToShow: 6,
                                        slidesToScroll: 6
                                    }
                                },
                                {
                                breakpoint: 1920,
                                    settings: {
                                        arrows: itemArrows,
                                        dots: itemDots,
                                        slidesToShow: 5,
                                        slidesToScroll: 5
                                    }
                                },
                                {
                                breakpoint: 1780,
                                    settings: {
                                        arrows: itemArrows,
                                        dots: itemDots,                               
                                        slidesToShow: 5,
                                        slidesToScroll: 5,
                                        variableWidth: true
                                        
                                    }
                                },
                                {
                                breakpoint: 1470,
                                    settings: {
                                        arrows: itemArrows,
                                        dots: itemDots,
                                        slidesToShow: 5,
                                        slidesToScroll: 4,
                                        variableWidth: true
                                    }
                                },                          
                                {
                                breakpoint: 1280,
                                    settings: {
                                        arrows: itemArrowsMb,
                                        dots: itemDotsMb,
                                        slidesToShow: 4,
                                        slidesToScroll: 4,
                                        variableWidth: true
                                    }
                                },
                                {
                                breakpoint: 1200,
                                    settings: {
                                        arrows: itemArrowsMb,
                                        dots: itemDotsMb,
                                        slidesToShow: 3,
                                        slidesToScroll: 3,
                                        variableWidth: true
                                    }
                                },
                                {
                                breakpoint: 920,
                                    settings: {
                                        arrows: itemArrowsMb,
                                        dots: itemDotsMb,
                                        slidesToShow: 3,
                                        slidesToScroll: 2,
                                        variableWidth: true
                                    }
                                },
                                {
                                breakpoint: 767,
                                    settings: {
                                        arrows: itemArrowsMb,
                                        dots: itemDotsMb,
                                        slidesToShow: 2,
                                        slidesToScroll: 2,
                                        variableWidth: true
                                    }
                                },
                                {
                                breakpoint: 560,
                                    settings: {
                                        arrows: itemArrowsMb,
                                        dots: itemDotsMb,
                                        slidesToShow: 2,
                                        slidesToScroll: 1,
                                        variableWidth: true
                                    }
                                },
                                {
                                breakpoint: 320,
                                    settings: {
                                        arrows: itemArrowsMb,
                                        dots: itemDotsMb,
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        variableWidth: true
                                    }
                                }
                            ]
                        });

                        $checkRecentSlidesNumber = $('.recentlyViewed-row.products-carousel').attr('data-recent-products-number');
                        console.log("$checkRecentSlidesNumber: " + $checkRecentSlidesNumber);

                        if ( $checkRecentSlidesNumber == 1 )  {

                            productGrid.slick('unslick');

                        }

                        // Add clear all button to the slider container
                        if (!recentlyViewed.find('.clear-all-recently-viewed').length) {
                            recentlyViewed.find('.halo-block-header').append('<button class="clear-all-recently-viewed" aria-label="Clear Recently Viewed Products">Clear Recently Viewed</button>');
                        }

                        // Add remove buttons to each product item
                        productGrid.find('.product-item .card').each(function() {
                            if (!$(this).find('.remove-recently-viewed').length) {
                                $(this).prepend('<button class="remove-recently-viewed" aria-label="Remove Recently Viewed Product"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"></path></svg></button>');
                            }
                        });

                        // Function to update remove button visibility - always show remove buttons
                        var updateRemoveButtonVisibility = function() {
                            // Always show remove buttons regardless of count
                            productGrid.find('.remove-recently-viewed').show();
                        };

                        // Initial check for remove button visibility
                        updateRemoveButtonVisibility();

                        // Add click event handler for clear all button
                        recentlyViewed.on('click', '.clear-all-recently-viewed', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            //console.log('Clearing all recently viewed products');
                            
                            // Clear the cookie and localStorage
                            cookie.destroy();
                            localStorage.removeItem('shopify_recently_viewed');
                            
                            // Hide the entire recently viewed section
                            recentlyViewed.fadeOut(300, function() {
                                recentlyViewed.hide();
                            });
                        });

                        // Add click event handler for remove buttons
                        productGrid.on('click', '.remove-recently-viewed', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            var $card = $(this).closest('.card');
                            var $productElement = $(this).closest('.product');
                            var productHref = $card.find('a.card-title').attr('href');
                            
                            //console.log('Card element:', $card[0]);
                            //console.log('Product href found:', productHref);
                            
                            // Try different selectors to find the product link
                            if (!productHref) {
                                productHref = $card.find('a[href*="/products/"]').first().attr('href');
                                //console.log('Alternative product href found:', productHref);
                            }
                            
                            if (!productHref) {
                                console.error('No product href found in card');
                                return;
                            }
                            
                            var productHandle = productHref.replace('/products/', '');
                            
                            //console.log('Product handle to remove (decoded):', productHandle);
                            
                            // Try to remove both encoded and decoded versions
                            var encodedHandle = encodeURIComponent(productHandle);
                            //console.log('Product handle to remove (encoded):', encodedHandle);
                            
                            // Remove from shopify_recently_viewed cookie and localStorage
                            cookie.remove(productHandle);
                            cookie.remove(encodedHandle);
                            
                            // Console log updated values after removal
                            var updatedCookieValue = jQuery.cookie('shopify_recently_viewed');
                            var updatedLocalStorageValue = localStorage.getItem('shopify_recently_viewed');
                            
                            //console.log('Updated cookie value after removal:', updatedCookieValue);
                            //console.log('Updated localStorage value after removal:', updatedLocalStorageValue);
                            
                            // Always remove the slide visually, regardless of whether it was in the cookie
                            // This handles cases where the slider shows more products than what's in the cookie
                            if ($productElement.length && productGrid.hasClass('slick-initialized')) {
                                // Get the correct slide index using Slick's data attribute
                                var slideIndex = parseInt($productElement.attr('data-slick-index'));
                                //console.log('Slick slide index:', slideIndex);
                                //console.log('Product element:', $productElement[0]);
                                
                                // Check if this is a cloned slide or has invalid index
                                var isCloned = $productElement.hasClass('slick-cloned');
                                var needsOriginalSlide = isCloned || slideIndex < 0 || isNaN(slideIndex);
                                
                                //console.log('Is cloned slide:', isCloned);
                                //console.log('Needs original slide lookup:', needsOriginalSlide);
                                
                                if (needsOriginalSlide) {
                                    //console.log('Invalid/cloned slide detected, finding original. Current index:', slideIndex);
                                    // Find the original slide by matching product handle
                                    var originalSlide = productGrid.find('.product:not(.slick-cloned)').filter(function() {
                                        var $this = $(this);
                                        var thisHref = $this.find('a.card-title').attr('href') || $this.find('a[href*="/products/"]').first().attr('href');
                                        return thisHref && thisHref.includes(productHandle);
                                    }).first();
                                    
                                    if (originalSlide.length) {
                                        slideIndex = parseInt(originalSlide.attr('data-slick-index'));
                                        //console.log('Found valid original slide index:', slideIndex);
                                    } else {
                                        console.error('Could not find valid slide index, falling back to manual removal');
                                        // Fallback to manual removal
                                        $productElement.fadeOut(300, function() {
                                            $(this).remove();
                                            updateRemoveButtonVisibility();
                                        });
                                        return;
                                    }
                                }
                                
                                //console.log('Using slide index:', slideIndex);
                                
                                // Use slickRemove to properly remove the slide
                                productGrid.slick('slickRemove', slideIndex);
                                
                                // Remove from cookie/localStorage after slick removal
                                // (this was already done above)
                                
                                // Check remaining products after removal
                                setTimeout(function() {
                                    var remainingProducts = productGrid.find('.product').length;
                                    
                                    if (remainingProducts <= 0) {
                                        // Hide the entire recently viewed section if no products left
                                        recentlyViewed.hide();
                                    } /*else if (remainingProducts == 1) {
                                        // Destroy slider if only 1 product left
                                        productGrid.slick('unslick');
                                        updateRemoveButtonVisibility();
                                    } */ else {
                                        // Update remove button visibility for remaining slides
                                        updateRemoveButtonVisibility();
                                    }
                                }, 50);
                            } else if ($productElement.length) {
                                // Fallback for non-slider case
                                $productElement.fadeOut(300, function() {
                                    $(this).remove();
                                    
                                    // Add a small delay to ensure DOM is updated before checking
                                    setTimeout(function() {
                                        // Check remaining products after removal (handle both slider and non-slider cases)
                                        var remainingProducts = productGrid.find('.product').length;
                                        
                                        if (remainingProducts <= 0) {
                                            // Hide the entire recently viewed section if no products left
                                            recentlyViewed.hide();
                                        } else if (remainingProducts == 1 && productGrid.hasClass('slick-initialized')) {
                                            // Destroy slider if only 1 product left
                                            productGrid.slick('unslick');
                                            // Update remove button visibility after destroying slider
                                            updateRemoveButtonVisibility();
                                        } else if (productGrid.hasClass('slick-initialized')) {
                                            // Always reinitialize slider after removal for multiple products
                                            
                                            //console.log('Calling slick reInit, remaining products:', remainingProducts);
                                            productGrid.slick('reInit');
                                            // Update remove button visibility after reinitializing slider
                                            updateRemoveButtonVisibility();
                                        } else {
                                            // Update remove button visibility for non-slider cases
                                            updateRemoveButtonVisibility();
                                        }
                                    }, 50);
                                });
                            }
                        });

                    }
                }

                if ($('body').hasClass('cursor-fixed__show')){
                    window.sharedFunctionsAnimation.onEnterButton();
                    window.sharedFunctionsAnimation.onLeaveButton();
                }
            }
        }
    };

    return {
        resizeImage: function (src, size) {
            if (size == null) {
                return src;
            }

            if (size == 'master') {
                return src.replace(/http(s)?:/, "");
            }

            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

            if (match != null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];

                return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
            } else {
                return null;
            }
        },

        showRecentlyViewed: function (params) {
            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            productHandleQueue = cookie.read();

            // Template and element where to insert.
            template = config.templateId;
            wrapper = jQuery('#' + config.wrapperId);

            // How many products to show.
            config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

            // If we have any to show.
            if (config.howManyToShow && wrapper.length) {
                // Getting each product with an Ajax call and rendering it on the page.
                if (template == 'recently-viewed-product-popup') {
                    const wrapperP = wrapper;
                    moveAlong(wrapperP);
                } else {
                    const wrapperS = wrapper;
                    doAlong(wrapperS);
                }
            }
        },

        getConfig: function () {
            return config;
        },

        clearList: function () {
            cookie.destroy();
        },

        recordRecentlyViewed: function (params) {
            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            var recentlyViewed = cookie.read();

            // If we are on a product page.
            if (window.location.pathname.indexOf('/products/') !== -1) {
                // What is the product handle on this page.
                var splitted = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
                if (splitted == null) {
                    var productHandle = decodeURIComponent(window.location.pathname.split('/products/')[1]);
                } else {
                    var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                }
                // In what position is that product in memory.
                var position = jQuery.inArray(productHandle, recentlyViewed);
                // If not in memory.
                if (position === -1) {
                    // Add product at the start of the list.
                    recentlyViewed.unshift(productHandle);
                    // Only keep what we need.
                    recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                } else {
                    // Remove the product and place it at start of list.
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }

                // Update cookie.
                cookie.write(recentlyViewed);
            }
        }
    };
})();
